import { IntlMessageID } from "~/providers/I18nProvider";
import { UpdateExpiredPasswordStatus } from "../types/updateExpiredPassword";

export const UpdateExpiredPasswordError: Record<
  string,
  { message: IntlMessageID; description?: IntlMessageID }
> = {
  //Keys come from backend
  [UpdateExpiredPasswordStatus.UserNamePasswordError]: {
    message: "UpdateExpiredPassword.Error.userNamePasswordError.message",
    description:
      "UpdateExpiredPassword.Error.userNamePasswordError.description",
  },
  [UpdateExpiredPasswordStatus.OnlyExpiredUserPassword]: {
    message: "UpdateExpiredPassword.Error.onlyExpiredUserPassword.message",
    description:
      "UpdateExpiredPassword.Error.onlyExpiredUserPassword.description",
  },
  [UpdateExpiredPasswordStatus.UserLocked]: {
    message: "UpdateExpiredPassword.Error.userLocked.message",
    description: "UpdateExpiredPassword.Error.userLocked.description",
  },
};
